import "./resultat.css";
import { useState, useContext, useEffect } from "react";
import {
  FaCalculator,
  FaCog,
  FaFilePowerpoint,
  FaFileWord,
  FaIdBadge,
  FaPrint,
  FaChartLine,
  FaBuilding,
  FaPiggyBank,
  FaDollarSign,
  FaHome,
  FaReceipt,
  FaUserTie,
  FaUmbrella,
  FaUmbrellaBeach,
  FaLayerGroup,
} from "react-icons/fa";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import RemunerationTNS from "./modules/remunerationTNS";
import RemunerationSalarie from "./modules/RemunerationSalarie";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import DetailTNSPageModal from "./detail/rémuneration/detailTNSPager";
import DetailSalariePageModal from "./detail/rémuneration/detailSalariePager";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { AuditCompletPptx, AuditCompletWord } from "components/app/Api/Rapport/ApiRapport";
import { Menu, MenuItem } from "@mui/material";
import CompactFinancialCard, { CompactFinancialContainer, FINANCIAL_THEMES, CompactFinancialCardTwoColumn } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";

const ResultatPage = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const [ClientConjoint, setClientConjoint] = useState("");
  const [modalDetail, setModalDetail] = useState(false);
  const [modalDetailConjoint, setModalDetailConjoint] = useState(false);
  const PeriodeClient = context.state["PeriodeActuelle"][0];
  const Periode = context.state["PeriodeActuelle" + ClientConjoint][0];
  const PeriodeConjoint = context.state["PeriodeActuelleConjoint"][0];
  const Prenom = context.state["Prenom" + ClientConjoint];
  const [AffichConjointAssocie, setAffichConjointAssocie] = useState(false);
  const [brutImposableClient, setBrutImposableClient] = useState(false);
  const [goForClient, setGoForClient] = useState(false);
  const [brutImposableConjoint, setBrutImposableConjoint] = useState(0);
  const [goForConjointAssocie, setGoForConjointAssocie] = useState(false);
  const [goForConjoint, setGoForConjoint] = useState(false);
  const getBrutImposable = (result) => Number(result?.BrutImposable ?? result ?? 0);

  useEffect(() => {
    if (PeriodeClient !== undefined) {
      if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, ClientConjoint).then((brutImposable) => {
          setBrutImposableClient(getBrutImposable(brutImposable));
          setGoForClient(true);
        });
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, ClientConjoint).then((brutImposable) => {
          setBrutImposableClient(getBrutImposable(brutImposable));
          setGoForClient(true);
        });
      }

      if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
        setAffichConjointAssocie(true);
        if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
          ResultatTNS.GetResultRemExpert(context.state, "ConjointAssocie").then((brutImposable) => {
            setBrutImposableConjoint(getBrutImposable(brutImposable));
            setGoForConjointAssocie(true);
          });
        } else {
          ResultatSalarie.GetResultRemExpert(context.state, "ConjointAssocie").then((brutImposable) => {
            setBrutImposableConjoint(getBrutImposable(brutImposable));
            setGoForConjointAssocie(true);
          });
        }
      } else {
        setGoForConjointAssocie(true);
        setAffichConjointAssocie(false);
      }
    }
    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, "Conjoint").then((brutImposable) => {
          setBrutImposableConjoint(getBrutImposable(brutImposable));
          setGoForConjoint(true);
        });
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, "Conjoint").then((brutImposable) => {
          setBrutImposableConjoint(getBrutImposable(brutImposable));
          setGoForConjoint(true);
        });
      }
    } else {
      setGoForConjoint(true);
    }
  }, [ClientConjoint, context.state.AgeDepartProjection, context.state.AgeDepartProjectionConjoint]);

  useEffect(() => {
    if (goForClient === true && goForConjoint === true && goForConjointAssocie === true) {
      if (Periode !== undefined) {
        const DividendeClient = PeriodeClient && PeriodeClient.DividendeBrut ? PeriodeClient.DividendeBrut : 0;
        const DividendeConjoint = PeriodeConjoint && PeriodeConjoint.DividendeBrut ? PeriodeConjoint.DividendeBrut : 0;
        ResultatTNS.GetImpot("", context.state, brutImposableClient, brutImposableConjoint, Number(DividendeClient) + Number(DividendeConjoint)).then(() => {});
      }
    }
  }, [goForClient, goForConjoint, goForConjointAssocie]);

  const handleGetEnvEntreprise = () => {
    let EnvEntr = 0;
    if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
      EnvEntr += ResultatTNS.state["RemunerationTNS" + ClientConjoint].CoutRemuneration + ResultatTNS.state["RemunerationTNS" + ClientConjoint].CotisationsFacultativesFraisPro;
    } else {
      EnvEntr += ResultatSalarie.state["RemunerationSalarie" + ClientConjoint].CoutRemuneration;
    }

    if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
      if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
        EnvEntr += ResultatTNS.state.RemunerationTNSConjoint.CoutRemuneration + ResultatTNS.state.RemunerationTNSConjoint.CotisationsFacultativesFraisPro;
      } else {
        EnvEntr += ResultatSalarie.state.RemunerationSalarieConjoint.CoutRemuneration;
      }
    }
    EnvEntr += Periode?.ResAvtIs;
    return EnvEntr;
  };
  const handleRevenusPercus = () => {
    let RevPercus = 0;
    if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
      RevPercus += Number(ResultatTNS.state["RemunerationTNS"].RemunerationNette);
    } else {
      RevPercus += Number(ResultatSalarie.state["RemunerationSalarie"].SalaireNet);
    }
    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        RevPercus += Number(ResultatTNS.state["RemunerationTNSConjoint"].RemunerationNette);
      } else {
        RevPercus += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].SalaireNet);
      }
    }
    if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
      if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
        RevPercus += Number(ResultatTNS.state.RemunerationTNSConjoint.RemunerationNette);
      } else {
        RevPercus += Number(ResultatSalarie.state.RemunerationSalarieConjoint.SalaireNet);
      }
    }
    const DividendeClient = PeriodeClient && PeriodeClient.DividendeBrut ? PeriodeClient.DividendeBrut : 0;
    const DividendeConjoint = PeriodeConjoint && PeriodeConjoint.DividendeBrut ? PeriodeConjoint.DividendeBrut : 0;

    RevPercus += Number(DividendeClient) + Number(DividendeConjoint);
    return RevPercus;
  };

  const handleCotisationsFacPerso = () => {
    let CotFacPerso = 0;
    if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
      CotFacPerso += Number(ResultatTNS.state["RemunerationTNS"].VersementFacultatifPerso);
    } else {
      CotFacPerso += Number(ResultatSalarie.state["RemunerationSalarie"].VersementFacultatifPerso);
    }
    if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
      if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
        CotFacPerso += Number(ResultatTNS.state.RemunerationTNSConjoint.VersementFacultatifPerso);
      } else {
        CotFacPerso += Number(ResultatSalarie.state.RemunerationSalarieConjoint.VersementFacultatifPerso);
      }
    }
    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        CotFacPerso += Number(ResultatTNS.state["RemunerationTNSConjoint"].VersementFacultatifPerso);
      } else {
        CotFacPerso += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].VersementFacultatifPerso);
      }
    }

    return CotFacPerso;
  };

  const handleRevenusDispo = () => {
    return handleRevenusPercus() + ResultatTNS.state.DetailImpot?.AutresRevenusFoyer - handleCotisationsFacPerso() - ResultatTNS.state.DetailImpot?.IRTotal;
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCotisationsProductives = () => {
    let cotProductiveRetraiteObligatoire = 0;
    let cotProductiveRetraiteFacultative = 0;

    // Pour le client
    if (PeriodeClient?.Statut === "TNS Article 62" || PeriodeClient?.Statut === "TNS individuel") {
      cotProductiveRetraiteObligatoire += Number(ResultatTNS.state["RemunerationTNS"].Rapport?.RetraiteObligatoire || 0);
      cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNS"].Rapport?.RetraiteFacultative || 0);
      cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNS"].Rapport?.TotalPEEProductif || 0);
      cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNS"].Rapport?.TotalPERCOProductif || 0);
    } else if (PeriodeClient) {
      cotProductiveRetraiteObligatoire += Number(ResultatSalarie.state["RemunerationSalarie"].Rapport?.RetraiteObligatoire || 0);
      cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarie"].Rapport?.RetraiteFacultative || 0);
      cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarie"].Rapport?.TotalPEEProductif || 0);
      cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarie"].Rapport?.TotalPERCOProductif || 0);
    }

    // Pour le conjoint
    if (context.state.InclureConjoint === true && PeriodeClient?.StatutConjoint !== "Aucun" && ClientConjoint === "") {
      if (PeriodeClient?.StatutConjoint === "TNS Article 62" || PeriodeClient?.StatutConjoint === "TNS individuel") {
        cotProductiveRetraiteObligatoire += Number(ResultatTNS.state.RemunerationTNSConjoint.Rapport?.RetraiteObligatoire || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state.RemunerationTNSConjoint.Rapport?.RetraiteFacultative || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state.RemunerationTNSConjoint.Rapport?.TotalPEEProductif || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state.RemunerationTNSConjoint.Rapport?.TotalPERCOProductif || 0);
      } else {
        cotProductiveRetraiteObligatoire += Number(ResultatSalarie.state.RemunerationSalarieConjoint.Rapport?.RetraiteObligatoire || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state.RemunerationSalarieConjoint.Rapport?.RetraiteFacultative || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state.RemunerationSalarieConjoint.Rapport?.TotalPEEProductif || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state.RemunerationSalarieConjoint.Rapport?.TotalPERCOProductif || 0);
      }
    }

    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        cotProductiveRetraiteObligatoire += Number(ResultatTNS.state["RemunerationTNSConjoint"].Rapport?.RetraiteObligatoire || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNSConjoint"].Rapport?.RetraiteFacultative || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNSConjoint"].Rapport?.TotalPEEProductif || 0);
        cotProductiveRetraiteFacultative += Number(ResultatTNS.state["RemunerationTNSConjoint"].Rapport?.TotalPERCOProductif || 0);
      } else {
        cotProductiveRetraiteObligatoire += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].Rapport?.RetraiteObligatoire || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].Rapport?.RetraiteFacultative || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].Rapport?.TotalPEEProductif || 0);
        cotProductiveRetraiteFacultative += Number(ResultatSalarie.state["RemunerationSalarieConjoint"].Rapport?.TotalPERCOProductif || 0);
      }
    }

    return cotProductiveRetraiteObligatoire + cotProductiveRetraiteFacultative;
  };

  if (!Periode) {
    return;
  }

  return (
    <>
      <Column fill>
        {((context.state.InclureConjoint === true && Periode?.StatutConjoint === "Aucun" && PeriodeConjoint) || ClientConjoint === "Conjoint") && (
          <Row>
            <Column fill style={{ maxWidth: "1256px" }}>
              <CardBox bpad style={{ padding: "4px" }}>
                <table>
                  <tr>
                    <td>Sélectionnez une situation professionnelle</td>
                    <td>
                      <DropDown
                        value={ClientConjoint}
                        onChange={(e) => setClientConjoint(e.target.value)}
                        options={[
                          { value: "", label: "Situation professionnelle pour " + context.state.Prenom },
                          { value: "Conjoint", label: "Situation professionnelle pour " + context.state.PrenomConjoint },
                        ]}
                        xlarge
                      />
                    </td>
                  </tr>
                </table>
              </CardBox>
            </Column>
          </Row>
        )}
        <Row>
          <Column fill rpad style={{ maxWidth: "640px" }}>
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaBuilding className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title">Enveloppe entreprise</span>
              </div>
              <div className="resultat-header-card-value">{applyFormat(handleGetEnvEntreprise(), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
            {Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel" ? (
              <RemunerationTNS Resultat={ResultatTNS.state["RemunerationTNS" + ClientConjoint]} Prenom={Prenom} />
            ) : (
              <RemunerationSalarie Resultat={ResultatSalarie.state["RemunerationSalarie" + ClientConjoint]} Prenom={Prenom} />
            )}
            {AffichConjointAssocie === true &&
              (Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel" ? (
                <RemunerationTNS Resultat={ResultatTNS.state.RemunerationTNSConjoint} Prenom={context.state.PrenomConjoint} />
              ) : (
                <RemunerationSalarie Resultat={ResultatSalarie.state.RemunerationSalarieConjoint} Prenom={context.state.PrenomConjoint} />
              ))}
            {(Periode?.Statut !== "TNS individuel" || Periode?.ModeExercice === "IS") && (
              <CompactFinancialContainer title="Résultat avant IS" subtitle="Analyse financière de l'entreprise">
                <CompactFinancialCard
                  icon={<FaChartLine />}
                  title="Résultat avant IS"
                  value={applyFormat(Periode?.ResAvtIs, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  theme={FINANCIAL_THEMES.success}
                />

                <CompactFinancialCard
                  icon={<FaBuilding />}
                  title="Impôt sur les sociétés"
                  value={applyFormat(Periode?.ImpotSoc, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  theme={FINANCIAL_THEMES.danger}
                />

                <CompactFinancialCard
                  icon={<FaPiggyBank />}
                  title={`Mise en réserve${Periode?.DividendeBrutAutres !== 0 ? " / div. autres associés" : ""}`}
                  value={applyFormat(Number(Periode?.Reserve) + Number(Periode?.DividendeBrutAutres), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  theme={FINANCIAL_THEMES.purple}
                />

                <CompactFinancialCard
                  icon={<FaDollarSign />}
                  title="Dividendes bruts"
                  value={applyFormat(Periode?.DividendeBrut, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  theme={FINANCIAL_THEMES.primary}
                />
              </CompactFinancialContainer>
            )}
            <CompactFinancialContainer title="Analyse des revenus" subtitle="Détail des revenus et charges fiscales">
              <CompactFinancialCard
                icon={<FaChartLine />}
                title="Revenus d'activités perçus"
                value={applyFormat(handleRevenusPercus(), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                theme={FINANCIAL_THEMES.primary}
              />

              <CompactFinancialCard
                icon={<FaHome />}
                title="Autres revenus du foyer"
                value={applyFormat(ResultatTNS.state.DetailImpot?.AutresRevenusFoyer, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                theme={FINANCIAL_THEMES.primary}
              />

              <CompactFinancialCard
                icon={<FaReceipt />}
                title="Impôt sur le revenu"
                value={applyFormat(ResultatTNS.state.DetailImpot?.IRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                theme={FINANCIAL_THEMES.danger}
              />

              <CompactFinancialCard
                icon={<FaUserTie />}
                title="Cotisations facultatives personnelles"
                value={applyFormat(handleCotisationsFacPerso(), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                theme={FINANCIAL_THEMES.orange}
              />
            </CompactFinancialContainer>
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaCalculator className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title">Revenu disponible</span>
              </div>
              <div className="resultat-header-card-value">{applyFormat(handleRevenusDispo(), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaChartLine className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title">Cotisations productives en matière de retraite</span>
              </div>
              <div className="resultat-header-card-value">{applyFormat(handleCotisationsProductives(), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </Column>
          <Column fill lpad style={{ maxWidth: "600px" }}>
            {/* Cartes d'action compactes - Disposition 2x2 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                padding: "12px",
                background: "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.98) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                border: "1px solid rgba(255,255,255,0.9)",
                marginBottom: "5px",
              }}
            >
              {/* Première ligne - 2 boutons */}
              <div style={{ display: "flex", gap: "8px" }}>
                {/* Carte Détails - Version compacte */}
                <div
                  onClick={() => setModalDetail(true)}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(59, 130, 246, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.3)";
                  }}
                >
                  {/* Mini graphiques décoratifs */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      display: "flex",
                      gap: "2px",
                      alignItems: "end",
                    }}
                  >
                    <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px" }}></div>
                    <div style={{ width: "2px", height: "10px", background: "white", borderRadius: "1px" }}></div>
                    <div style={{ width: "2px", height: "4px", background: "white", borderRadius: "1px" }}></div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaCalculator style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Détail des calculs {Prenom}
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Charges sociales et impôt
                    </div>
                  </div>
                </div>
                {/* Carte Détails Conjoint - Version compacte (si applicable) */}
                {context.state.InclureConjoint === true && Periode?.StatutConjoint !== "Aucun" && ClientConjoint === "" ? (
                  <div
                    onClick={() => setModalDetailConjoint(true)}
                    style={{
                      background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                      borderRadius: "8px",
                      padding: "12px",
                      color: "white",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(245, 158, 11, 0.3)",
                      flex: 1,
                      minHeight: "60px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 6px 15px rgba(245, 158, 11, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.3)";
                    }}
                  >
                    {/* Mini assistant décoratif */}
                    <div
                      style={{
                        position: "absolute",
                        top: "6px",
                        right: "8px",
                        opacity: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "1px",
                      }}
                    >
                      <div style={{ width: "8px", height: "6px", background: "white", borderRadius: "2px" }}></div>
                      <div style={{ width: "6px", height: "4px", background: "white", borderRadius: "1px" }}></div>
                      <div style={{ width: "2px", height: "3px", background: "white" }}></div>
                    </div>

                    <div
                      style={{
                        background: "rgba(255,255,255,0.2)",
                        borderRadius: "6px",
                        padding: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaCalculator style={{ fontSize: "14px" }} />
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          marginBottom: "2px",
                        }}
                      >
                        Détails {context.state.PrenomConjoint}
                      </div>
                      <div
                        style={{
                          fontSize: "10px",
                          opacity: 0.8,
                          fontWeight: "400",
                        }}
                      >
                        Calculs pour le conjoint
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      padding: "12px",
                      flex: 1,
                    }}
                  ></div>
                )}
              </div>

              {/* Deuxième ligne - 2 boutons */}
              <div style={{ display: "flex", gap: "8px" }}>
                {/* Carte Simulation - Version compacte */}
                <div
                  onClick={() => props.GoToSimulation()}
                  style={{
                    background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(124, 58, 237, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(124, 58, 237, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(124, 58, 237, 0.3)";
                  }}
                >
                  {/* Mini simulations décoratives */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                      <div style={{ width: "6px", height: "1px", background: "white" }}></div>
                      <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                      <div style={{ width: "4px", height: "1px", background: "white" }}></div>
                      <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
                    </div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaCog style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Simulations
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Générer des scénarios d'optimisation
                    </div>
                  </div>
                </div>
                {/* Carte Impression - Version compacte */}
                <div
                  onClick={handleClick}
                  style={{
                    background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(5, 150, 105, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(5, 150, 105, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(5, 150, 105, 0.3)";
                  }}
                >
                  {/* Mini document décoratif */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      width: "12px",
                      height: "15px",
                      background: "white",
                      borderRadius: "2px",
                    }}
                  >
                    <div style={{ width: "8px", height: "1px", background: "#059669", margin: "3px 2px 1px 2px" }}></div>
                    <div style={{ width: "6px", height: "1px", background: "#059669", margin: "1px 2px" }}></div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaPrint style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Impression
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Editer un Word ou ppt
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Menu d'impression */}
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <MenuItem
                onClick={() => {
                  AuditCompletPptx(context.state, ResultatTNS.state, ResultatSalarie.state).then((res) => {});
                  handleClose();
                }}
                disableRipple
              >
                <FaFilePowerpoint style={{ color: "#cc4424", marginRight: "10px" }} />
                <div style={{ paddingTop: "4px" }}> Etude simplifiée </div>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  AuditCompletWord(context.state, ResultatTNS.state, ResultatSalarie.state).then((res) => {});
                  handleClose();
                }}
                disableRipple
              >
                <FaFileWord style={{ color: "#2c5698", marginRight: "10px" }} />
                <div style={{ paddingTop: "4px" }}> Etude complète </div>
              </MenuItem>
            </Menu>
            <CompactFinancialContainer title="Retraite" subtitle="Détail des prestations de retraite">
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaUmbrellaBeach />}
                  title="Retraite nette annuelle"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["Retraite" + ClientConjoint].TotalRetraiteNetteChoixDepartRetraite +
                        ResultatTNS.state["Retraite" + ClientConjoint].TotalCapitalFractionneChoixDepartRetraite
                      : ResultatSalarie.state["Retraite" + ClientConjoint].TotalRetraiteNetteChoixDepartRetraite +
                        ResultatSalarie.state["Retraite" + ClientConjoint].TotalCapitalFractionneChoixDepartRetraite
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.RetraiteConjoint.TotalRetraiteNetteChoixDepartRetraite + ResultatTNS.state.RetraiteConjoint.TotalCapitalFractionneChoixDepartRetraite
                      : ResultatSalarie.state.RetraiteConjoint.TotalRetraiteNetteChoixDepartRetraite + ResultatSalarie.state.RetraiteConjoint.TotalCapitalFractionneChoixDepartRetraite
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.primary}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaUmbrellaBeach />}
                  title="Retraite nette annuelle"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(
                          ResultatTNS.state["Retraite" + ClientConjoint].TotalRetraiteNetteChoixDepartRetraite +
                            ResultatTNS.state["Retraite" + ClientConjoint].TotalCapitalFractionneChoixDepartRetraite,
                          "uint",
                          { thousands: " ", decimal: ",", unit: " €" }
                        )
                      : applyFormat(
                          ResultatSalarie.state["Retraite" + ClientConjoint].TotalRetraiteNetteChoixDepartRetraite +
                            ResultatSalarie.state["Retraite" + ClientConjoint].TotalCapitalFractionneChoixDepartRetraite,
                          "uint",
                          { thousands: " ", decimal: ",", unit: " €" }
                        )
                  }
                  theme={FINANCIAL_THEMES.primary}
                />
              )}
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaLayerGroup />}
                  title="Dont rentes obligatoires"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalPensionNette
                      : ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalPensionNette
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalPensionNette
                      : ResultatSalarie.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalPensionNette
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.purple}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaLayerGroup />}
                  title="Dont rentes obligatoires"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalPensionNette, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalPensionNette, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.purple}
                />
              )}
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaLayerGroup />}
                  title="Dont rentes facultatives"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalRenteNette
                      : ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalRenteNette
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalRenteNette
                      : ResultatSalarie.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalRenteNette
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.purple}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaLayerGroup />}
                  title="Dont rentes facultatives"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalRenteNette, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalRenteNette, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.purple}
                />
              )}
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaLayerGroup />}
                  title="Dont capitaux fractionnés"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalCapitalFractionne
                      : ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalCapitalFractionne
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalCapitalFractionne
                      : ResultatSalarie.state.RetraiteConjoint.InfosRetraiteChoixDepart.TotalCapitalFractionne
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.purple}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaLayerGroup />}
                  title="Dont capitaux fractionnés"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalCapitalFractionne, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart.TotalCapitalFractionne, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.purple}
                />
              )}
            </CompactFinancialContainer>
            <CompactFinancialContainer title="Prévoyance" subtitle="Détail des prestations de prévoyance">
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaUmbrella />}
                  title="IJ max"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["PrevTNS" + ClientConjoint].IJMax
                      : ResultatSalarie.state["PrevSalarie" + ClientConjoint].IJMax
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.PrevTNSConjoint.IJMax
                      : ResultatSalarie.state.PrevSalarieConjoint.IJMax
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.prevoyance}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaUmbrella />}
                  title="IJ max"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["PrevTNS" + ClientConjoint].IJMax, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["PrevSalarie" + ClientConjoint].IJMax, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.prevoyance}
                />
              )}
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaUmbrella />}
                  title="Invalidité totale"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["PrevTNS" + ClientConjoint].InvaliditeTotale
                      : ResultatSalarie.state["PrevSalarie" + ClientConjoint].InvaliditeTotale
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.PrevTNSConjoint.InvaliditeTotale
                      : ResultatSalarie.state.PrevSalarieConjoint.InvaliditeTotale
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.prevoyance}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaUmbrella />}
                  title="Invalidité totale"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["PrevTNS" + ClientConjoint].InvaliditeTotale, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["PrevSalarie" + ClientConjoint].InvaliditeTotale, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.prevoyance}
                />
              )}
              {AffichConjointAssocie === true ? (
                <CompactFinancialCardTwoColumn
                  icon={<FaUmbrella />}
                  title="Décès"
                  valueClient={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? ResultatTNS.state["PrevTNS" + ClientConjoint].CapitalDeces
                      : ResultatSalarie.state["PrevSalarie" + ClientConjoint].CapitalDeces
                  }
                  valueConjoint={
                    Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel"
                      ? ResultatTNS.state.PrevTNSConjoint.CapitalDeces
                      : ResultatSalarie.state.PrevSalarieConjoint.CapitalDeces
                  }
                  labelClient={Prenom}
                  labelConjoint={context.state.PrenomConjoint}
                  theme={FINANCIAL_THEMES.prevoyance}
                  format={{ thousands: " ", decimal: ",", unit: " €" }}
                />
              ) : (
                <CompactFinancialCard
                  icon={<FaUmbrella />}
                  title="Décès"
                  value={
                    Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                      ? applyFormat(ResultatTNS.state["PrevTNS" + ClientConjoint].CapitalDeces, "uint", { thousands: " ", decimal: ",", unit: " €" })
                      : applyFormat(ResultatSalarie.state["PrevSalarie" + ClientConjoint].CapitalDeces, "uint", { thousands: " ", decimal: ",", unit: " €" })
                  }
                  theme={FINANCIAL_THEMES.prevoyance}
                />
              )}
            </CompactFinancialContainer>
          </Column>
        </Row>
      </Column>

      {/* MODAL DETAIL CLIENT */}
      <Modal
        width="80%"
        height="82%"
        title="Détails"
        icon={<FaIdBadge />}
        visible={modalDetail}
        onClose={() => {
          setModalDetail(false);
        }}
      >
        {Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel" ? (
          <DetailTNSPageModal
            Outil=""
            Prenom={Prenom}
            Caisse={Periode?.Caisse}
            DetailImpot={ResultatTNS.state.DetailImpot}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerp}
            InfosDisponible={ResultatTNS.state["RemunerationTNS" + ClientConjoint].Rapport.DispoDepaMadelin}
            GraphDisponible={ResultatTNS.state["RemunerationTNS" + ClientConjoint].GraphDisponible}
            DetailCotisations={ResultatTNS.state["RemunerationTNS" + ClientConjoint].DetailCotisations}
            DetailAssiette={ResultatTNS.state["RemunerationTNS" + ClientConjoint].DetailAssiette}
            DetailCSG={ResultatTNS.state["RemunerationTNS" + ClientConjoint].DetailCSG}
            TotalChargesSociales={ResultatTNS.state["RemunerationTNS" + ClientConjoint].TotalChargesSociales}
            DetailAssietteClient={ResultatTNS.state["RemunerationTNS" + ClientConjoint].DetailAssiette}
            DetailAssietteConjoint={
              PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel"
                ? ResultatTNS.state.RemunerationTNSConjoint.DetailAssiette
                : ResultatSalarie.state.RemunerationSalarieConjoint.DetailFicheDePaie
            }
            TabIJ={ResultatTNS.state["PrevTNS" + ClientConjoint].TabIJ}
            GraphIJ={ResultatTNS.state["PrevTNS" + ClientConjoint].ImgGraphIncap}
            TabInval={ResultatTNS.state["PrevTNS" + ClientConjoint].TabInval}
            GraphInval={ResultatTNS.state["PrevTNS" + ClientConjoint].ImgGraphInval}
            TabDeces={ResultatTNS.state["PrevTNS" + ClientConjoint].TabDeces}
            TabRente={ResultatTNS.state["PrevTNS" + ClientConjoint].TabRente}
            InfosRetraiteChoixDepart={ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart}
            InfosRetraite={ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraite}
            ClientConjoint={ClientConjoint}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        ) : (
          <DetailSalariePageModal
            Outil=""
            Prenom={Prenom}
            DetailImpot={ResultatTNS.state.DetailImpot}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerp}
            DetailFicheDePaie={ResultatSalarie.state["RemunerationSalarie" + ClientConjoint].DetailFicheDePaie}
            DetailAssietteClient={ResultatSalarie.state["RemunerationSalarie" + ClientConjoint].DetailFicheDePaie}
            DetailAssietteConjoint={
              PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel"
                ? ResultatTNS.state.RemunerationTNSConjoint.DetailAssiette
                : ResultatSalarie.state.RemunerationSalarieConjoint.DetailFicheDePaie
            }
            InfosDisponible={ResultatSalarie.state["RemunerationSalarie" + ClientConjoint].Rapport.InfosDisponible}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
            GraphDisponible={ResultatSalarie.state["RemunerationSalarie" + ClientConjoint].GraphDisponible}
            TabIJ={ResultatSalarie.state["PrevSalarie" + ClientConjoint].TabIJ}
            GraphIJ={ResultatSalarie.state["PrevSalarie" + ClientConjoint].ImgGraphIncap}
            TabInval={ResultatSalarie.state["PrevSalarie" + ClientConjoint].TabInval}
            GraphInval={ResultatSalarie.state["PrevSalarie" + ClientConjoint].ImgGraphInval}
            TabDeces={ResultatSalarie.state["PrevSalarie" + ClientConjoint].TabDeces}
            TabRente={ResultatSalarie.state["PrevSalarie" + ClientConjoint].TabRente}
            InfosRetraiteChoixDepart={ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart}
            InfosRetraite={ResultatSalarie.state["Retraite" + ClientConjoint].InfosRetraite}
            ClientConjoint={ClientConjoint}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        )}
      </Modal>

      {/* MODAL DETAIL CONJOINT */}
      <Modal
        width="80%"
        height="82%"
        title="Details"
        icon={<FaIdBadge />}
        visible={modalDetailConjoint}
        onClose={() => {
          setModalDetailConjoint(false);
        }}
      >
        {Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel" ? (
          <DetailTNSPageModal
            Outil=""
            Prenom={context.state.PrenomConjoint}
            Caisse={Periode?.Caisse}
            InfosDisponible={ResultatTNS.state.RemunerationTNSConjoint.Rapport.DispoDepaMadelin}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
            DetailImpot={ResultatTNS.state.DetailImpot}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerpConjoint}
            GraphDisponible={ResultatTNS.state.RemunerationTNSConjoint.GraphDisponible}
            DetailCotisations={ResultatTNS.state.RemunerationTNSConjoint.DetailCotisations}
            DetailAssiette={ResultatTNS.state.RemunerationTNSConjoint.DetailAssiette}
            DetailCSG={ResultatTNS.state.RemunerationTNSConjoint.DetailCSG}
            TotalChargesSociales={ResultatTNS.state.RemunerationTNSConjoint.TotalChargesSociales}
            DetailAssietteClient={
              Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                ? ResultatTNS.state.RemunerationTNS.DetailAssiette
                : ResultatSalarie.state.RemunerationSalarie.DetailFicheDePaie
            }
            DetailAssietteConjoint={ResultatTNS.state.RemunerationTNSConjoint.DetailAssiette}
            TabIJ={ResultatTNS.state.PrevTNSConjoint.TabIJ}
            GraphIJ={ResultatTNS.state.PrevTNSConjoint.ImgGraphIncap}
            TabInval={ResultatTNS.state.PrevTNSConjoint.TabInval}
            GraphInval={ResultatTNS.state.PrevTNSConjoint.ImgGraphInval}
            TabDeces={ResultatTNS.state.PrevTNSConjoint.TabDeces}
            TabRente={ResultatTNS.state.PrevTNSConjoint.TabRente}
            InfosRetraiteChoixDepart={ResultatTNS.state.RetraiteConjoint.InfosRetraiteChoixDepart}
            InfosRetraite={ResultatTNS.state.RetraiteConjoint.InfosRetraite}
            ClientConjoint="Conjoint"
            visible={modalDetailConjoint}
            onClose={() => {
              setModalDetailConjoint(false);
            }}
          />
        ) : (
          <DetailSalariePageModal
            Outil=""
            Prenom={context.state.PrenomConjoint}
            DetailImpot={ResultatTNS.state.DetailImpot}
            DetailAssietteClient={
              Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel"
                ? ResultatTNS.state.RemunerationTNS.DetailAssiette
                : ResultatSalarie.state.RemunerationSalarie.DetailFicheDePaie
            }
            DetailAssietteConjoint={ResultatSalarie.state.RemunerationSalarieConjoint.DetailFicheDePaie}
            InfosDisponible={ResultatSalarie.state.RemunerationSalarieConjoint.Rapport.InfosDisponible}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerpConjoint}
            DetailFicheDePaie={ResultatSalarie.state.RemunerationSalarieConjoint.DetailFicheDePaie}
            GraphDisponible={ResultatSalarie.state.RemunerationSalarieConjoint.GraphDisponible}
            TabIJ={ResultatSalarie.state.PrevSalarieConjoint.TabIJ}
            GraphIJ={ResultatSalarie.state.PrevSalarieConjoint.ImgGraphIncap}
            TabInval={ResultatSalarie.state.PrevSalarieConjoint.TabInval}
            GraphInval={ResultatSalarie.state.PrevSalarieConjoint.ImgGraphInval}
            TabDeces={ResultatSalarie.state.PrevSalarieConjoint.TabDeces}
            TabRente={ResultatSalarie.state.PrevSalarieConjoint.TabRente}
            InfosRetraiteChoixDepart={ResultatSalarie.state.RetraiteConjoint.InfosRetraiteChoixDepart}
            InfosRetraite={ResultatSalarie.state.RetraiteConjoint.InfosRetraite}
            ClientConjoint="Conjoint"
            visible={modalDetailConjoint}
            onClose={() => {
              setModalDetailConjoint(false);
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default ResultatPage;
